import { Component, OnInit, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {Pipe} from '@angular/core';
import {IOption} from 'ng-select';
declare  const $;
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
import * as moment from 'moment/moment';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AlertComponent } from './../alert/alert.component';
import { Popup } from 'ng2-opd-popup';
import { debugOutputAstAsTypeScript } from '@angular/compiler';


@Component({
  selector: 'app-pma-category',
  templateUrl: './pma-category.component.html',
  styleUrls: ['./pma-category.component.scss']
})

export class PmaCategoryComponent implements OnInit {
	search:any
	ListOfModelDetails=[];
	ListOfPreventiveMaintenanceDetails=[];
	labourcostDetailsArray=[]
	ToolTip="Delete is not allowed since it is used in Pma Contract page";
	btnName:any='Submit';
	isValid:boolean = true;
	ListPmaCategoryDetails:any[] = [];
	msgtext:any;
	startingCount:number = 0;
	endingCount:number = 0;
	p: number = 1;
	//newmake:string;
	newPmaCategory_err:boolean=false;
	EditObjectId:any;
	@ViewChild('add') add: Popup;
	@ViewChild('update') update: Popup;
	@ViewChild('Askdelete') Askdelete: Popup;
	@ViewChild('delete') delete: Popup;
	@ViewChild('duplicate') duplicate: Popup;
	duplicateMessage: string = 'This PMA Category Already Exists';
	deleteId:any;
	orgId:number;
	userId:number;
	loading:boolean=true;
	pmacategory:any="";
	//getmake={};
	constructor(private dialogService:DialogService,private http: Http,private toastyService:ToastyService,private toastyConfig: ToastyConfig,private router:Router,private route : ActivatedRoute) {}

	ngOnInit() {
		     
//		this.loading=true;
		if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
	    	window.location.href = 'https://still.alshirawi.com/highmessaging/';
	    } else {
	      this.orgId=this.route.params['value'].orgId;
	      this.userId=this.route.params['value'].userId;
	      console.log('OrgId '+ this.orgId);
	      console.log('UserId '+ this.userId);
	    }
		
			//this.getAllMakedetails();
			this.checkTooltip();
	}

	checkTooltip() {
  if (this.ListPmaCategoryDetails.length == 0 || this.ListPmaCategoryDetails.length == undefined) {
    this.getAllPmaCategorydetails();
  } else {
    this.loadDeleteAvailability();
  }
}

	loadDeleteAvailability() {
		let pmaCategoryIds = [];

		for(let i=0;i<this.ListPmaCategoryDetails.length;i++) {
			this.ListPmaCategoryDetails[i].status = false;
			this.ListPmaCategoryDetails[i].deleteBlockedReason = '';
			pmaCategoryIds.push(this.ListPmaCategoryDetails[i]._id);
		}

		return this.http.post('/api/getPmaCategoryDeleteAvailability', {
			'ids':pmaCategoryIds,
			'orgId':this.orgId
		}).subscribe(
			res => {
				let availabilityResponse = res.json().availability || {};

				for(let i=0;i<this.ListPmaCategoryDetails.length;i++) {
					if(availabilityResponse[String(this.ListPmaCategoryDetails[i]._id)] && availabilityResponse[String(this.ListPmaCategoryDetails[i]._id)].canDelete === false) {
						this.ListPmaCategoryDetails[i].status = true;
						this.ListPmaCategoryDetails[i].deleteBlockedReason = availabilityResponse[String(this.ListPmaCategoryDetails[i]._id)].reason || this.ToolTip;
					}
				}

				this.loading = false;
			},(err) => {
				this.loading = false;
				if(err.status != 200){
					this.msgtext = "Unable to validate delete availability";
					this.getWarningFunction(this.msgtext);
				}
			}
		)
	}

	getAllPreventiveMaintenanceDetails() {
    this.loading=true;
      
      let reqPMSObj = {
        'orgId':this.orgId
      }
      return this.http.post('/api/getAllPreventiveMaintenanceDetails',reqPMSObj).subscribe(
       res => {
        
					let CustomerArr = []
					if(res.json().length>0){
						this.ListOfPreventiveMaintenanceDetails = res.json();
						this.checkTooltip();
					}else{
						this.loading=false;
					}
					
			 })
			}


	showAlertForAddingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"ADD PMA CATEGORY",message:"The Data added successfully"});
	}
	
	showAlertForUpdatingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"UPDATE PMA CATEGORY",message:"The Data updated successfully"});
	}

	addOk() {
		this.add.hide();
	}

	updateOk() {
		this.update.hide();
	}

	deleteOk() {
		this.delete.hide();
	}

	getAllPmaCategorydetails () {
		//this.getlabourcostdetails();
		let makeObj = {
			'orgId':this.orgId
		}
	    return this.http.post('/api/getPmaCategorydetails', makeObj).subscribe(
	    res => {
             
	        let ResponeMake = res.json();
			this.ListPmaCategoryDetails = ResponeMake;
			if(ResponeMake.length>0){
				console.log("this.ListPmaCategoryDetails ", this.ListPmaCategoryDetails );
				console.log('List Length '+ this.ListPmaCategoryDetails.length);
				console.log('List startingCount '+ this.startingCount);
				console.log('List endingCount '+ this.endingCount);
				this.getCount();
				this.loadDeleteAvailability();
			}else{
				this.loading=false;
			}

	    },(err) =>{
				this.loading=false;
	      if(err.status != 200){
	        this.msgtext = "Unable to load the Pma Category Value";
	        this.getWarningFunction(this.msgtext);
	      }
	    })
  	}

  	getCount(){
	   if(this.p < Math.ceil(this.ListPmaCategoryDetails.length/10)){
	     this.startingCount = (this.p-1)*10;
	     if(this.startingCount == 0){
	       this.startingCount = 1;
	     }
			 this.endingCount = this.p*10;
			 console.log('List Length '+ this.ListPmaCategoryDetails.length);
		console.log('List startingCount '+ this.startingCount);
		console.log('List endingCount '+ this.endingCount);
	   } else if(this.p == Math.ceil(this.ListPmaCategoryDetails.length/10)){
	     let count = this.ListPmaCategoryDetails.length%10;
	     this.startingCount = (this.p-1)*10;
	     this.endingCount = this.startingCount + count;
	     if(this.startingCount == 0){
	       this.startingCount = 1;
	       this.endingCount = count;
			 }
			 console.log('List Length '+ this.ListPmaCategoryDetails.length);
		console.log('List startingCount '+ this.startingCount);
		console.log('List endingCount '+ this.endingCount);
	   }
	  }

	  Inputmake() {
	  	if(this.pmacategory == "" || this.pmacategory == null || this.pmacategory == undefined) {
			this.newPmaCategory_err=true;
			this.isValid = false;
	  	} else {
			this.newPmaCategory_err=false;
			this.isValid = true;
	  	}
	  }
	  
	addmake() {
		this.loading=true;
		if(this.pmacategory == "" || this.pmacategory == undefined || this.pmacategory == null||/^\s*$/.test(this.pmacategory)) {
			this.newPmaCategory_err=true;
			this.loading=false;
		} else {
			// Duplicate check (case-insensitive, whitespace-normalized)
			let normalizedInput = this.pmacategory.trim().toLowerCase();
			if(this.EditObjectId == null || this.EditObjectId == undefined || this.EditObjectId == "") {
				let isDuplicate = this.ListPmaCategoryDetails.some((d: any) => d.pmacategory.trim().toLowerCase() === normalizedInput);
				if(isDuplicate) {
					this.loading = false;
					this.showDuplicatePopup('This PMA Category Already Exists');
					return;
				}
				let reqMakeObj = {
					'pmacategory': normalizedInput,
					'orgId':this.orgId,
					'created_By':this.userId,
					'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
				}
				return this.http.post('/api/addpmacategoryValue', reqMakeObj).subscribe(
					res => {
						let pmacategoryResponse = res.json();
						if(pmacategoryResponse.message == 'This Pma Category Already Exists') {
							this.loading=false;
							this.showDuplicatePopup('This PMA Category Already Exists');
						} else {
							this.showAlertForAddingdata();
							this.getAllPmaCategorydetails();
							this.Empty();
							this.loading=false;
						}
					},(err) =>{
						this.loading=false;
						if(err.status != 200){
							this.msgtext = "Unable to Add the Pma Category Value";
							this.getWarningFunction(this.msgtext);
						}
					})
			} else {
				let isDuplicateEdit = this.ListPmaCategoryDetails.some((d: any) => d._id !== this.EditObjectId && d.pmacategory.trim().toLowerCase() === normalizedInput);
				if(isDuplicateEdit) {
					this.loading = false;
					this.showDuplicatePopup('This PMA Category Already Exists');
					return;
				}
				let reqMakeObj = {
					'pmacategory': normalizedInput,
					'orgId':this.orgId,
					'updated_By':this.userId,
					'update_Date':moment.utc().format('YYYY:MM:DD h:mm:ss'),
					'objectId':this.EditObjectId
				}
				return this.http.post('/api/Updatepmacategorydetails', reqMakeObj).subscribe(
					res => {
						let pmacategoryResponse = res.json();
						if(pmacategoryResponse.message == 'This Pma Category Already Exist') {
							this.loading=false;
							this.showDuplicatePopup('This PMA Category Already Exists');
						} else {
							this.showAlertForUpdatingdata();
							this.getAllPmaCategorydetails();
							this.Empty();
							this.loading=false;
						}
					},(err) =>{
						this.loading=false;
						if(err.status != 200){
							this.msgtext = "Unable to Add the Pma Category Value";
							this.getWarningFunction(this.msgtext);
						}
					})
			}
		}
	}

	showDuplicatePopup(message: any) {
		this.duplicateMessage = message;
		this.duplicate.options = {
			showButtons: false,
			color: "#4180ab",
			header: "PMA Category"
		};
		this.duplicate.show(this.duplicate.options);
	}

	duplicateOk() {
		this.duplicate.hide();
	}

	// MYSQLEntryMakeAdd() {
	// 	     
	//     let reqMakeObj = {
	//         'make':this.newmake.trim().toLowerCase(),
	//         'orgId':this.orgId,
	//         'created_By':this.userId,
	//         'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
	//     }
	//     return this.http.post('/api/MYSQLaddmakeValue', reqMakeObj).subscribe(
	//       res => {
	      
	//         let makeResponse = res.json();
	//         this.showAlertForAddingdata();
	//         this.getAllPmaCategorydetails();
	// 				this.Empty();
	// 				this.loading=false;
	//     },(err)=>{
	//         this.loading=false;
	//         this.msgtext = "Unable to Add the Value in mysql";
	//         this.getWarningFunction(this.msgtext);
	//     })
  // 	}


  	// MYSQLEntryMakeUpdate() {
	  //   let reqMakeObj = {
	  //       'make':this.newmake.trim().toLowerCase(),
	  //       'orgId':this.orgId,
	  //       'updated_By':this.userId,
	  //       'update_Date':moment.utc().format('YYYY:MM:DD h:mm:ss'),
		// 	'EditObjectId':this.EditObjectId
	  //   }
	  //   return this.http.post('/api/MYSQLUpdateMakeDetails', reqMakeObj).subscribe(
	  //     res => {
	       
	  //       let makeResponse = res.json();
	  //       this.showAlertForUpdatingdata();
	  //       this.getAllPmaCategorydetails();
		// 			this.Empty();
		// 			this.loading=false;
	  //   },(err)=>{
	  //       this.loading=false;
	  //       this.msgtext = "Unable to Add the Value in mysql";
	  //       this.getWarningFunction(this.msgtext);
	  //   })
  	// }

	Editing(index, objectId) {
    console.log("ListPmaCategoryDetails",this.ListPmaCategoryDetails)
		this.Empty();
		this.EditObjectId = objectId;
		this.btnName = 'Update';
		for(let i=0;i<this.ListPmaCategoryDetails.length;i++) {
			if(this.ListPmaCategoryDetails[i]._id == objectId) {
				this.pmacategory = this.ListPmaCategoryDetails[i].pmacategory.toUpperCase();
			}
		}
		
	}


	Delete(index: any, deleteId: any) {
		// Prevent delete if status is true (used in contract)
		const cat = this.ListPmaCategoryDetails[index];
		if (cat && cat.status) {
			this.showDeleteBlockedPopup(cat.deleteBlockedReason || this.ToolTip);
			return;
		}
		this.Empty();
		this.deleteId = deleteId;
		this.Askdelete.options = {
			showButtons: false, // You can hide this in case you want to use custom 
			color: "#4180ab",
			header: "Delete PMA CATEGORY"
		};
		this.Askdelete.show(this.Askdelete.options);
	}

	showDeleteBlockedPopup(message: any) {
		this.msgtext = message;
		this.delete.options = {
			showButtons: false,
			color: "#d9534f",
			header: "Delete Blocked"
		};
		this.delete.show(this.delete.options);
	}

	No() {
		this.Askdelete.hide();
	}

	Yes() {
		this.Askdelete.hide();
		this.loading=true;
		let reqMakeObj = {
	        'deleteId':this.deleteId,
	        'orgId':this.orgId
	    }
	    return this.http.post('/api/deletepmacategoryDetails', reqMakeObj).subscribe(
	      res => {
          let makeResponse = res.json();
		  	if(makeResponse && makeResponse.canDelete === false) {
		  		this.loading=false;
		  		this.showDeleteBlockedPopup(makeResponse.reason || this.ToolTip);
		  		this.getAllPmaCategorydetails();
		  		return false;
		  	}
          this.delete.options = {
		        showButtons: false, // You can hide this in case you want to use custom 
		        color: "#4180ab",
		        header: "Pma Category Deleted"
		    };
		  	this.loading=false;
          this.delete.show(this.delete.options);
          this.deleteId="";
          this.getAllPmaCategorydetails();
          this.Empty();
	    },(err)=>{
	        this.loading=false;
	        this.msgtext = "Unable to Add the Pma Category Value in mysql";
	        this.getWarningFunction(this.msgtext);
	    })
	}



	deletesuccessOk() {
		this.delete.hide();
	}

	Empty() {
		this.pmacategory="";
		this.EditObjectId="";
		this.newPmaCategory_err=false;
		this.btnName='Submit';
		this.isValid=true;
	}

	reset() {
		this.Empty();
	}

    getWarningFunction(errMsg) {
	    var toastOptions:ToastOptions = {
	        title: "PMA CATEGORY",
	        msg: errMsg,
	        showClose: true,
	        timeout: 3000,
	        theme: 'bootstrap',
	        onAdd: (toast:ToastData) => {
	        },
	        onRemove: function(toast:ToastData) {
	        }
	    };
        this.toastyService.warning(toastOptions);
    }//getWarningFunction end here


  getSuccessFunction(successMsg){
    var toastOptions:ToastOptions = {
      title: "Pma Category",
      msg: successMsg,
      showClose: true,
      timeout: 3000,
      theme: 'bootstrap',
      onAdd: (toast:ToastData) => {
      },
      onRemove: function(toast:ToastData) {
      }
    };
    this.toastyService.success(toastOptions);
  }//getSuccessFunction end here


}




// WEBPACK FOOTER //
// ./client/app/pma-category/pma-category.component.ts